<template>
  <div>
    <div v-if="content" class="content editor-content">
      <div v-html="content" class="mce-content-body"></div>
    </div>
  </div>
</template>
<script>
import Prism from 'prismjs'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-cpp'

export default {
  props: { 'content': {}, 'needWaterMark': { default: false } },
  mounted () {
    Prism.highlightAllUnder(this.$el)
  },
  watch: {
    content () {
      this.$nextTick(() => {
        if (this.$el) {
          Prism.highlightAllUnder(this.$el)
        }
      })
    }
  }
}
</script>
<style>
.mce-content-body {
  overflow-x: auto;
}
</style>
